export const exportPageLang = {
    EXPORT: 'EXPORT',
    EXPORT_NETWORK: 'EXPORT NETWORK',
    QUALTY_INSPECTION:'Quality Inspection & Order Updates',
    EXPORT_RANGE:'Export Range',
    YOUR_BRAND_LABELLING:'Your Brand Labelling',

    EXPORT_NETWORK_DESC_1: 'Our extensive export network spans multiple continents, ensuring that your products reach global markets efficiently and reliably. Whether you are exporting agricultural goods, textiles, or manufactured products, our team is dedicated to facilitating smooth international trade operations. Currently, we are exporting to 15+ countries',

    EXPORT_NETWORK_DESC_2:'We do realize that long-term business can only be made with high-quality products, conomical prices, quick delivery and speedy service. Hence, the building of mutual trust and confidence by exporting products with value constantly stay at the top of our company policy.',

    EXPORT_NETWORK_DESC_3:'As a distinguished tile exporter in India, Luton Ceramic Pvt. Ltd. endows their customers with a comprehensive range of tiles best for use in interior decor of floors in residential & commercial spaces. We are a leading manufacturer of tiles in India dealing with advanced technology. We have been exporting the tiles for years now and delight in the beauty of our exquisite range of tiles that we supply to our customers spanning the globe.',

    EXPORT_NETWORK_DESC_4:`We understand clients, we provide private labelling according to client's requirements which helps customer's brands to grow in their market.`,

    GULF: 'GULF',
    AFRICA: 'AFRICA',
    ASIA: 'ASIA',
    EUROPE: 'EUROPE',

    COUNTRY_WE_EXPORT: 'Country We Export',
    GLOBAL_NETWORK: 'Global Network',
    GULF_COUNTRIES: 'Gulf Countries',
    AFRICA_COUNTRIES: 'African Countries',
    ASIA_COUNTRIES: 'Asian Countries',
    EUROPE_COUNTRIES: 'Europe Countries',

    OUR_CERTIFICATIONS: 'Our Certifications',
};